const constants = {
    formname: "newsletter"
}

export default constants